<template>
  <section class="newsletter">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1210.868" height="414.324" viewBox="0 0 1210.868 414.324"><defs><linearGradient id="nbg-a" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.08" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/></linearGradient><linearGradient id="nbg-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><linearGradient id="nbg-j" x1="0.094" y1="1.151" x2="1.083" y2="1.151" xlink:href="#nbg-b"/><linearGradient id="nbg-k" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#2fa3df"/><stop offset="0.505" stop-color="#ffe815"/><stop offset="0.994" stop-color="#ce1657"/></linearGradient><linearGradient id="nbg-l" x1="0" y1="0.5" x2="1" y2="0.5" xlink:href="#nbg-k"/><linearGradient id="nbg-m" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ffd400"/><stop offset="0.994" stop-color="#8abb2a"/></linearGradient><linearGradient id="nbg-n" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox"><stop offset="0.01" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/></linearGradient><linearGradient id="nbg-o" x1="0" y1="0.5" x2="1" y2="0.5" xlink:href="#nbg-a"/></defs><g transform="translate(-347.118 -5952.161)"><path d="M-11696.683,5875.693c96.434-25.953,226.987,181.738,178.619,252.688s-324.024,76.105-372.091,31.109S-11793.116,5901.646-11696.683,5875.693Z" transform="translate(12322.154 178)" opacity="0.12" fill="url(#nbg-a)"/><path d="M-11357.683,5833.418c207.09-22.754,612.36,49.38,748.985,129.086s121.062,113.843-23.2,179.309-356.566,109.7-556.479,83.16S-11564.772,5856.172-11357.683,5833.418Z" transform="translate(11991.963 123)" opacity="0.12" fill="url(#nbg-b)"/><path d="M30.607-.106C45.476-1.168,59.476,10.212,59.476,28.179s-14.614,31.03-31.769,33.9S0,50.391,0,32.425,15.738.955,30.607-.106Z" transform="translate(1390.283 6075.252) rotate(166)" opacity="0.23" fill="url(#nbg-b)"/><path d="M22.449-.124C33.354-.9,43.622,7.444,43.622,20.621S32.9,43.38,20.322,45.487,0,36.912,0,23.735,11.543.654,22.449-.124Z" transform="matrix(0.017, 1, -1, 0.017, 392.864, 6244.957)" opacity="0.23" fill="url(#nbg-a)"/><path d="M15.944.012C23.885-.3,31.526,5.468,31.766,14.256s-7.4,14.971-16.543,16.132S.245,24.277.005,15.489,8,.32,15.944.012Z" transform="translate(1375.09 6188.36) rotate(45)" opacity="0.23" fill="url(#nbg-b)"/><path d="M12.864.01c6.406-.249,12.571,4.4,12.765,11.493S19.656,23.581,12.282,24.518.2,19.588,0,12.5,6.458.258,12.864.01Z" transform="matrix(0.848, -0.53, 0.53, 0.848, 463.348, 6316.195)" opacity="0.23" fill="url(#nbg-a)"/><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="translate(1512.188 6113.231) rotate(76)" opacity="0.23" fill="url(#nbg-b)"/><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="translate(415.779 6168.963) rotate(-1)" opacity="0.23" fill="url(#nbg-a)"/><ellipse cx="4.316" cy="4.587" rx="4.316" ry="4.587" transform="translate(1557.986 6001.183) rotate(166)" opacity="0.23" fill="url(#nbg-b)"/><g transform="translate(806 5999.555)" opacity="0.084"><path d="M204.151,317.389a99.264,99.264,0,0,0,101.728-96.515l2.359-89.658a99.21,99.21,0,0,0-122.462-98.99v0l-.012.006q-3.122.747-6.177,1.7l-.014,0a98.446,98.446,0,0,0-11.772,4.51l-.521.246q-2.51,1.172-4.953,2.484c-.249.133-.5.261-.744.4a98.624,98.624,0,0,0-10.189,6.423c-.405.292-.8.593-1.207.892q-1.819,1.35-3.584,2.79c-.431.35-.863.695-1.288,1.054-1.511,1.274-3,2.579-4.446,3.951-1.3,1.23-2.553,2.5-3.775,3.789-.373.394-.729.8-1.094,1.2-.842.918-1.676,1.844-2.481,2.788-.391.46-.767.929-1.149,1.4-.758.923-1.505,1.855-2.226,2.8q-.53.695-1.042,1.4-1.107,1.5-2.151,3.045c-.284.42-.57.837-.848,1.262q-1.142,1.741-2.2,3.526c-.179.3-.368.6-.547.909a98.048,98.048,0,0,0-5.025,9.842h0l-.02.046a98.127,98.127,0,0,0-5.937,18.086c-.026.113-.043.226-.067.339-.321,1.447-.617,2.9-.868,4.374-.058.318-.093.645-.145.967-.208,1.265-.408,2.536-.567,3.812-.081.663-.13,1.334-.2,2-.1.947-.211,1.89-.281,2.842q-.182,2.444-.249,4.909l-1.774,67.439h0l-.582,22.216A99.264,99.264,0,0,0,204.151,317.389ZM131.528,126.573c.023-.822.078-1.638.124-2.455.906-12.236,6.05-26.564,11.746-36.767a78.067,78.067,0,0,1,5.129-7.242c.127-.159.261-.313.388-.472.863-1.057,1.76-2.093,2.68-3.109.249-.275.5-.553.753-.828,1.08-1.158,2.188-2.3,3.346-3.4,1.094-1.036,2.217-2.026,3.358-2.99.336-.287.683-.559,1.025-.839q1.259-1.033,2.556-2.009.547-.408,1.1-.813,1.454-1.051,2.955-2.032c.234-.156.466-.318.7-.472,1.3-.828,2.611-1.621,3.948-2.368l.11-.058c1.279-.712,2.579-1.378,3.893-2.015.246-.119.492-.232.738-.35q1.771-.829,3.578-1.575c.206-.084.408-.171.614-.252a76.715,76.715,0,0,1,8.881-2.947,77.683,77.683,0,0,1,97.551,77.066l-2.359,89.655a77.614,77.614,0,1,1-155.174-4.079Z" transform="translate(-63.939 -29.456)" fill="url(#nbg-j)"/><g transform="translate(0 44.699)"><path d="M147.954,233.291c-2.35-4.692-5.21-9.726-6.8-14.8a97.953,97.953,0,0,1-2.961-9.567c-1.074-5.008-1.36-9.792-1.511-9.943A77.568,77.568,0,0,1,191.454,66.695l89.687-.255c9.737-.026,20.306,1.563,28.908,4.828A75.983,75.983,0,0,0,293.631,45.6c-3.653-.4-8.791-.715-12.551-.706l-89.687.258a99.145,99.145,0,0,0-43.439,188.135Z" transform="translate(-92.519 -44.898)" fill="url(#nbg-k)"/><path d="M283.193,165.443q-.721,1.858-1.54,3.673l-.035.078q-.794,1.763-1.673,3.474l-.1.2c-.562,1.088-1.152,2.162-1.76,3.219-.067.113-.13.229-.2.342-.579.993-1.184,1.968-1.8,2.932-.107.168-.211.336-.321.5-.588.9-1.2,1.777-1.824,2.649-.153.214-.3.431-.452.64-.593.813-1.213,1.607-1.838,2.4-.194.246-.382.5-.582.744-.622.764-1.268,1.511-1.919,2.252-.211.24-.411.489-.625.727q-1.3,1.441-2.663,2.819c-.376.376-.79.712-1.175,1.083l-.006.049a78.156,78.156,0,0,1-12.759,9.986c-.616.385-1.242.758-1.87,1.129-.263.153-.53.307-.8.46q-2.887,1.654-5.931,3.06c-.368.171-.735.342-1.106.507-.579.258-1.158.507-1.743.75-.466.194-.935.376-1.407.562q-1.255.491-2.536.944c-.573.2-1.146.4-1.725.591q-.742.239-1.491.466-.964.291-1.942.559c-.408.113-.813.232-1.224.339-1,.258-2.02.492-3.039.712-.388.081-.776.156-1.164.234-.79.153-1.58.3-2.379.431-.35.058-.7.119-1.054.174-1.1.168-2.214.316-3.332.434-.243.026-.492.043-.738.069q-1.411.135-2.84.223c-.327.02-.657.041-.987.058-1.175.055-2.359.1-3.549.1l-17.8.052-21.7.061a10.967,10.967,0,0,0-2.3-.246l-28.55.081a10.947,10.947,0,0,0-2.3.261h-.272l-.009.087a11,11,0,0,0,2.643,21.7l28.55-.081a11.027,11.027,0,0,0,2.287-.255l17.75-.052h0l21.762-.061c1.083,0,2.159-.026,3.233-.064.4-.014.8-.041,1.193-.058.669-.032,1.334-.064,2-.107.5-.035,1-.081,1.494-.122.553-.046,1.1-.09,1.65-.142.564-.058,1.123-.124,1.685-.188.469-.055.941-.11,1.407-.171.619-.081,1.233-.171,1.847-.263.394-.061.787-.119,1.181-.182q1.012-.165,2.018-.353l.929-.174c.741-.145,1.479-.3,2.214-.457.214-.046.425-.093.637-.142q1.233-.278,2.452-.582l.258-.067A98.956,98.956,0,0,0,274.9,213l.017-.015q1.242-1.055,2.452-2.151l.148-.136q1.142-1.038,2.246-2.11l.246-.234c.706-.689,1.4-1.387,2.084-2.1.1-.1.2-.206.3-.31q1-1.042,1.968-2.116c.107-.116.214-.232.321-.35.643-.718,1.276-1.45,1.9-2.185l.3-.344q1-1.2,1.968-2.426c.043-.058.09-.11.133-.168q1.012-1.294,1.98-2.62c.281-.385.553-.782.828-1.169.344-.489.695-.973,1.03-1.465.362-.53.706-1.065,1.057-1.6.24-.368.483-.729.718-1.1.373-.585.732-1.181,1.094-1.774.153-.255.316-.5.466-.758l0-.006A99.024,99.024,0,0,0,254.556,48.417c2.547,5.074,7.364,13.052,9.06,21.125,1.236,5.882,2.009,12.936,2.232,13.159a77.368,77.368,0,0,1,17.345,82.742Z" transform="translate(-22.009 -38.231)" fill="url(#nbg-l)"/></g><path d="M329.707,62.987a99.262,99.262,0,0,0-140.226,0L126.062,126.4a99.219,99.219,0,0,0,20.705,156.1h0l.012.006q2.779,1.6,5.65,3.019l.012.006a97.758,97.758,0,0,0,11.645,4.828c.182.064.365.122.547.182q2.627.877,5.3,1.607c.272.075.541.153.813.226a98.937,98.937,0,0,0,11.813,2.353c.495.067.993.122,1.488.182q2.249.274,4.521.446c.553.04,1.1.087,1.659.122,1.971.116,3.951.191,5.946.191,1.789,0,3.572-.055,5.346-.148.541-.029,1.08-.081,1.618-.119,1.245-.087,2.484-.182,3.717-.316.6-.064,1.2-.145,1.795-.22,1.187-.148,2.368-.31,3.546-.5.573-.093,1.146-.194,1.717-.3q1.837-.33,3.656-.727c.495-.11.99-.217,1.482-.333,1.352-.318,2.692-.669,4.026-1.042.339-.1.683-.182,1.022-.284a97.766,97.766,0,0,0,10.421-3.679h0l.046-.023a97.876,97.876,0,0,0,16.754-9.031c.1-.064.185-.136.281-.2,1.23-.831,2.446-1.685,3.641-2.573.261-.194.512-.405.77-.6,1.022-.779,2.041-1.56,3.037-2.379.515-.423,1.013-.877,1.52-1.311.724-.619,1.456-1.227,2.162-1.87q1.815-1.646,3.56-3.39l47.7-47.7h0l15.715-15.715A99.262,99.262,0,0,0,329.707,62.987ZM251.06,251.4c-.582.582-1.187,1.135-1.78,1.693-9.08,8.255-22.671,15.107-33.829,18.589a78.964,78.964,0,0,1-8.7,1.725c-.2.026-.405.046-.6.072-1.355.177-2.718.31-4.084.411-.373.029-.744.061-1.117.084-1.58.1-3.167.159-4.765.159-1.505,0-3-.055-4.492-.139-.443-.026-.883-.067-1.323-.1-1.083-.081-2.162-.179-3.236-.3-.454-.052-.906-.107-1.358-.165q-1.78-.239-3.543-.559c-.278-.049-.559-.093-.834-.145q-2.266-.434-4.5-1l-.119-.035c-1.418-.362-2.819-.773-4.212-1.216-.261-.084-.518-.171-.776-.258q-1.858-.612-3.682-1.317c-.205-.081-.414-.159-.619-.24a76.9,76.9,0,0,1-8.467-3.974,77.682,77.682,0,0,1-17.727-123.05l63.418-63.418A77.615,77.615,0,1,1,314.475,187.982Z" transform="translate(-83.902 -20.867)" fill="url(#nbg-m)"/><g transform="translate(13.18 13.147)"><path d="M339.389,79.175a98.338,98.338,0,0,1-16.4,30.113,77.566,77.566,0,0,1-132.408,56.5l-63.418-63.418A77.135,77.135,0,0,1,111.244,79.2a77.7,77.7,0,0,0-6.718,30.081,98.715,98.715,0,0,0,7.4,8.319l63.418,63.418A99.147,99.147,0,0,0,339.389,79.175Z" transform="translate(-82.95 51.596)" fill="url(#nbg-n)"/><path d="M165.052,62q1.832-.8,3.691-1.5l.081-.029q1.811-.682,3.644-1.265l.208-.067q1.754-.556,3.526-1.022c.124-.035.252-.069.379-.1q1.667-.434,3.352-.787c.194-.043.388-.09.582-.127,1.051-.217,2.1-.4,3.164-.576.258-.041.515-.09.773-.13,1-.151,1.994-.272,2.993-.385.313-.035.625-.081.938-.113.981-.1,1.965-.165,2.95-.226.321-.02.637-.052.955-.069q1.937-.1,3.879-.1c.533,0,1.062.058,1.595.069l.041-.032a78.12,78.12,0,0,1,16.077,2.009c.709.165,1.415.344,2.122.53.3.078.591.159.886.24q3.209.881,6.351,2.046c.382.142.761.281,1.14.428q.881.343,1.76.706c.466.194.926.4,1.389.6.825.362,1.641.741,2.458,1.132.547.266,1.094.53,1.635.808.463.237.923.483,1.381.729.593.318,1.181.648,1.766.981.368.211.738.417,1.1.634q1.337.795,2.649,1.653c.33.214.657.437.987.66.666.449,1.329.909,1.983,1.381.29.208.579.414.868.625.894.666,1.783,1.346,2.654,2.055.191.156.379.318.57.475q1.094.907,2.162,1.855c.246.22.489.437.735.66.868.8,1.731,1.6,2.573,2.446l12.589,12.589,15.339,15.341a11.072,11.072,0,0,0,1.447,1.8l20.187,20.19a11.22,11.22,0,0,0,1.806,1.447l.194.191.067-.055A11,11,0,0,0,316.2,112.538L296.013,92.351a10.821,10.821,0,0,0-1.795-1.442L281.667,78.358h0L266.282,62.971q-1.151-1.146-2.327-2.249c-.289-.272-.588-.535-.883-.8-.492-.449-.984-.9-1.485-1.343-.376-.33-.758-.648-1.14-.975-.42-.356-.839-.718-1.262-1.068s-.88-.709-1.323-1.059c-.37-.3-.738-.59-1.112-.88q-.742-.569-1.491-1.123c-.318-.237-.64-.475-.961-.706q-.829-.6-1.673-1.184c-.258-.179-.518-.359-.779-.535q-.938-.638-1.884-1.25l-.55-.35q-1.064-.677-2.142-1.329l-.229-.133a98.922,98.922,0,0,0-42.421-13.625H204.6q-1.624-.139-3.251-.223l-.2-.009q-1.537-.078-3.08-.107c-.113,0-.226-.006-.339-.006-.987-.017-1.971-.014-2.955,0l-.434.006c-.961.017-1.925.052-2.886.1-.159.009-.318.012-.475.02-.964.049-1.928.116-2.892.194-.151.014-.3.02-.452.035-1.036.087-2.073.194-3.106.316-.072.009-.142.014-.214.02q-1.628.2-3.254.443c-.472.072-.944.162-1.413.24-.591.1-1.181.191-1.769.3-.625.116-1.251.249-1.876.379-.428.087-.857.171-1.285.263-.68.151-1.355.316-2.029.478-.289.069-.579.13-.865.2l0,.006a99.032,99.032,0,0,0-69.56,127.82,98.323,98.323,0,0,1,16.369-30.014A77.384,77.384,0,0,1,165.052,62Z" transform="translate(-97.072 -33.998)" fill="url(#nbg-o)"/></g></g></g></svg>
    <div class="newsletter-form" :success="success">
      <h2 class="success">Thank you for subscribing to our newsletter!</h2>
      <h2>Get the latest Information about CAST</h2>
      <form @submit.prevent="subscribe">
        <input placeholder="Enter your email here" v-model="email" type="email" maxlength="255" required :disabled="loading">
        <div class="loader" v-if="loading"></div>
        <button type="submit" class="ic" v-else>
          <i class="fas fa-long-arrow-alt-right"></i>
        </button>
      </form>
      <p class="error" v-if="error">{{error}}</p>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'newsletter',
  computed: {
    ...mapGetters({
      functions: 'getFunctions'
    })
  },
  data() {
    return {
      error: null,
      email: '',
      loading: false,
      success: false
    }
  },
  methods: {
    subscribe() {
      if(this.loading) return
      this.error = null
      this.loading = true
      this.functions.httpsCallable('subscribeNewsletter')({
        email: this.email
      })
      .then(() => {
        this.email = ''
        this.loading = false
        this.success = true
      })
      .catch(err => {
        this.error = err.message
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.newsletter {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1210px;
  max-width: calc(100% - 48px);
  height: 414px;
  margin: 0 auto;
  /* background: url(../assets/cast_bg_newsletter.png) no-repeat center/contain; */
}

.newsletter > svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.newsletter h2 {
  font: 400 3.93em/1 'Butler';
}

.newsletter .success {
  position: absolute;
  left: 0;
  right: 0;
  opacity: 0;
}

.newsletter .newsletter-form {
  position: relative;
  width: 570px;
  margin-left: 120px;
}

.newsletter .newsletter-form p {
  width: 374px;
  margin: 14px 0;
}

.newsletter .newsletter-form .error {
  color: #ff6666;
}

.newsletter .newsletter-form > * {
  transition: opacity .16s ease-out;
}

.newsletter .newsletter-form[success] > * {
  opacity: 0;
  pointer-events: none;
}

.newsletter .newsletter-form[success] > .success {
  opacity: 1;
  transition-delay: .16s;
}

.newsletter .newsletter-form form {
  position: relative;
  width: 397px;
  max-width: 100%;
}

.newsletter .newsletter-form input {
  display: block;
  width: 100%;
  height: 56px;
  background: none;
  border: none;
  border-bottom: 1px solid;
  border-radius: 0;
  -webkit-appearance: none;
  font: inherit;
  color: inherit;
  padding: 0;
}

.newsletter .newsletter-form input[disabled] {
  opacity: .3;
}

.newsletter .newsletter-form input::placeholder {
  text-transform: uppercase;
  font-weight: bold;
  color: #343434;
}

.newsletter .newsletter-form .loader,
.newsletter .newsletter-form .ic {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.newsletter .newsletter-form .loader {
  width: 32px;
  height: 32px;
  color:#00A1ED;
}

.newsletter .newsletter-form .ic i {
  font-size: 1.43em;
}

@media screen and (max-width: 1024px) {
  .newsletter {
    padding-top: 74px;
    height: 224px;
    align-items: flex-start;
    width: auto;
    max-width: none;
    overflow: hidden;
    background: url(../assets/cast_m_newsletter.svg) no-repeat center/500px auto;
  }
  .newsletter h2 {
    width: 290px;
    font-size: 28px;
    margin-bottom: 16px;
  }
  .newsletter > svg {
    display: none;
  }
  .newsletter .newsletter-form {
    width: 310px;
    margin: 0;
  }
  .newsletter .newsletter-form input {
    color: #343434;
    height: 60px;
  }
  .newsletter .newsletter-form input::placeholder {
    opacity: .77;
    color: #343434;
  }
  .newsletter .newsletter-form .ic {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border: 1px solid;
    color: #00A1ED;
    border-radius: 50%;
  }
}
</style>
